import { Component, OnInit } from "@angular/core";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { PropertyDetailsDto } from "../../dto";
import { UtilService } from "../../util.service";
import { catchError } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { HttpPropertyService } from "../../http-property.service";


@Component({
	selector: 'app-invoice-list',
	templateUrl: './property-list.component.html',
	styleUrls: ['./property-list.component.scss']
})
export class PropertyListComponent implements OnInit {
	properties: PropertyDetailsDto[];
	util = UtilService;

	constructor(
		private httpService: HttpPropertyService, 
		private spinner: NgxSpinnerService,
		private toastService: AppToastService,
		private router: Router) {
	}

	ngOnInit(): void {
		this.fetchAllProperties();
	}

	private fetchAllProperties() {
		this.spinner.show();
		this.httpService.getAll()
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error fetching properties', error);
				this.toastService.showDanger({ content: 'Failed to fetch data: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(items => {
			this.properties = items;
			this.spinner.hide();
		});
	}

	viewProperty(property: PropertyDetailsDto) {
		
	}
}